module.exports = __webpack_public_path__ + "static/safari-pinned-tab.e47a92e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/favicons/safari-pinned-tab.svg
// module id = 499
// module chunks = 114276838955818